"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateFeesDto = exports.CreateFeesDto = exports.FeeDto = exports.CreateFeeDto = exports.FeeFieldsDto = exports.UpdateFeeDto = exports.FeesIdsDto = exports.CalculateFeesDto = exports.CalculateFeeDto = exports.FindFeeFiltersDto = exports.FeeFiltersFieldsDto = exports.FindFeesFiltersDto = void 0;
class FindFeesFiltersDto {
}
exports.FindFeesFiltersDto = FindFeesFiltersDto;
class FeeFiltersFieldsDto {
}
exports.FeeFiltersFieldsDto = FeeFiltersFieldsDto;
class FindFeeFiltersDto extends FeeFiltersFieldsDto {
}
exports.FindFeeFiltersDto = FindFeeFiltersDto;
class CalculateFeeDto extends FeeFiltersFieldsDto {
}
exports.CalculateFeeDto = CalculateFeeDto;
class CalculateFeesDto extends FeeFiltersFieldsDto {
}
exports.CalculateFeesDto = CalculateFeesDto;
class FeesIdsDto {
}
exports.FeesIdsDto = FeesIdsDto;
class UpdateFeeDto {
}
exports.UpdateFeeDto = UpdateFeeDto;
class FeeFieldsDto {
}
exports.FeeFieldsDto = FeeFieldsDto;
class CreateFeeDto extends FeeFieldsDto {
}
exports.CreateFeeDto = CreateFeeDto;
class FeeDto extends FeeFieldsDto {
}
exports.FeeDto = FeeDto;
class CreateFeesDto {
}
exports.CreateFeesDto = CreateFeesDto;
class UpdateFeesDto {
}
exports.UpdateFeesDto = UpdateFeesDto;
//# sourceMappingURL=fee.dto.js.map